'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var DialogTitle = function DialogTitle(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'h2',
    {
      className: (0, _classnames2.default)(_constants.HEADER_TITLE, className)
    },
    children
  );
};
DialogTitle.propTypes = propTypes;
exports.default = DialogTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Dialog/DialogTitle.js
// module id = 272
// module chunks = 0